import React, { useEffect, useState, lazy } from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { AlertCircleIcon, TimerIcon, FlameIcon } from 'lucide-react';
const DAYS = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
const MONTHS = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
const getSecondsUntilEndOfDay = () => {
  const now = new Date();
  const endOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999);
  return Math.max(0, Math.floor((endOfDay.getTime() - now.getTime()) / 1000));
};
const getTodayLabel = () => {
  const now = new Date();
  return `${DAYS[now.getDay()]} ${now.getDate()} de ${MONTHS[now.getMonth()]}`;
};
export function UrgencyOfferSection() {
  const [timeLeft, setTimeLeft] = useState(getSecondsUntilEndOfDay);
  const [todayLabel, setTodayLabel] = useState(getTodayLabel);
  useEffect(() => {
    const interval = setInterval(() => {
      const remaining = getSecondsUntilEndOfDay();
      setTimeLeft(remaining);
      if (remaining > 86390) {
        setTodayLabel(getTodayLabel());
      }
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const pad = (n: number) => String(n).padStart(2, '0');
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-black py-12 md:py-16 px-4 border-y-4 border-gray-900 relative overflow-hidden pt-[25px] pb-[25px] mt-[-25px] mb-[-25px]" data-id="element-420">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-2xl h-full bg-red-900/20 blur-[100px] pointer-events-none rounded-full" data-id="element-421"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-422">
        <div className="text-center mb-10" data-id="element-423">
          <div className="inline-flex items-center gap-2 bg-red-600/20 text-red-500 px-6 py-2 rounded-full font-black text-sm md:text-base uppercase tracking-widest border border-red-500/50 mb-6" data-id="element-424">
            Oferta por tiempo limitado
          </div>

          <h2 className="md:text-5xl font-black text-white mb-3 text-[20px]" data-id="element-425">
            ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
          </h2>
          <p className="text-red-400 font-bold text-base md:text-xl mb-6 drop-shadow-[0_0_8px_rgba(220,38,38,0.6)]" data-id="element-426">
            Finaliza hoy {todayLabel}
          </p>
        </div>

        {/* Neon Countdown Timer */}
        <div className="flex justify-center mb-10" data-id="element-427">
          <div className="bg-gray-900 border-2 border-red-600 rounded-3xl p-6 md:p-10 animate-neon-red text-center min-w-[300px] md:min-w-[400px]" data-id="element-428">
            <div className="flex items-center justify-center gap-3 mb-4 text-red-500" data-id="element-429">
              <TimerIcon className="w-8 h-8" data-id="element-430" />
              <span className="text-xl font-bold uppercase tracking-widest" data-id="element-431">
                Tiempo Restante
              </span>
            </div>
            <div className="text-6xl md:text-8xl font-black text-red-500 tracking-wider font-mono animate-pulse-fast drop-shadow-[0_0_15px_rgba(220,38,38,0.8)]" data-id="element-432">
              {pad(hours)}:{pad(minutes)}:{pad(seconds)}
            </div>
          </div>
        </div>

        {/* Scarcity Bar */}
        <div className="bg-gray-900/80 rounded-2xl p-6 md:p-8 border border-gray-800 pt-[20px] pb-[20px] mt-[20px] mb-[20px]" data-id="element-433">
          <div className="flex justify-between items-end mb-3" data-id="element-434">
            <div className="flex items-center gap-2 text-red-500 font-bold text-lg md:text-xl uppercase" data-id="element-435">
              ¡SOLO QUEDAN 10 CUPOS!
            </div>
            <span className="text-gray-400 font-medium" data-id="element-436">75% Lleno</span>
          </div>
          <div className="w-full h-6 bg-gray-800 rounded-full overflow-hidden border border-gray-700" data-id="element-437">
            <motion.div initial={{
            width: '0%'
          }} animate={{
            width: '65%'
          }} transition={{
            duration: 1.5,
            ease: 'easeOut'
          }} className="h-full bg-gradient-to-r from-red-700 to-red-500 relative" data-id="element-438">
              <div className="absolute inset-0 bg-[linear-gradient(45deg,rgba(255,255,255,0.2)_25%,transparent_25%,transparent_50%,rgba(255,255,255,0.2)_50%,rgba(255,255,255,0.2)_75%,transparent_75%,transparent)] bg-[length:20px_20px] animate-[slide_1s_linear_infinite]" data-id="element-439"></div>
            </motion.div>
          </div>
        </div>

        {/* Certificate Image */}
        <div className="flex justify-center mb-10" data-id="element-440">
          <div className="max-w-md w-full border-2 border-[#FC9DFF] rounded-2xl shadow-[0_0_30px_rgba(252,157,255,0.3)] overflow-hidden" data-id="element-441">
            <img src="https://cdn.magicpatterns.com/uploads/wEfg1Mt7g6bJyrajpwkGx7/ChatGPT_Image_13_jun_2026,_01_15_19_a.m._(1).png" alt="Certifícate en días, clientas en semanas - Luxury Browes" loading="lazy" className="w-full h-auto object-cover block mt-[-2px] mb-[-2px]" data-id="element-442" />
          </div>
        </div>

        <div className="text-center mt-10" data-id="element-443">
          <CTAButton text="APROVECHAR OFERTA AHORA 👉🏻" onClick={scrollToCompra} size="large" className="w-full md:w-auto text-2xl" data-id="element-444" />
        </div>
      </div>
    </section>;
}